import {
  ObservationRefFragment,
  ObservationsDocument,
  ObservationsQuery,
  withNewStandardListHook,
} from '@spotify/confidence-graphql';

export const useObservations = withNewStandardListHook<
  ObservationsQuery,
  ObservationRefFragment,
  'observations'
>(ObservationsDocument, 'observations', {
  typename: 'ObservationsV1ListObservationsResponse',
  fragmentName: 'ObservationRef',
});
